import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { requiredProperty, invalidType } from '@/helpers/mixins/LocalizationHelper';
import { AlertType } from '@/helpers/entities/enums/AlertType';
import PhotoMixin from '@/helpers/vue_mixins/v2/PhotoMixin';
import OrangeThemeMixin from '@/helpers/vue_mixins/v2/OrangeThemeMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import FormHeader from '@/components/v2/FormHeader.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import { PsgcCityModel } from '@/helpers/entities/models/PsgcCityModel';
import { PsgcRegionModel } from '@/helpers/entities/models/PsgcRegionModel';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import DefaultBillingAddress from '@/plugins/graphql/queries/v2/default-billing-address.gql';
import CreateXenditPaymentMethod from '@/plugins/graphql/mutations/create-xendit-payment-method.gql';
import CreateXenditCardPaymentMethod from '@/plugins/graphql/mutations/create-xendit-card-payment-method.gql';
import CustomerDetails from '@/plugins/graphql/queries/v2/customer-details.gql';
import PsgcRegions from '@/plugins/graphql/queries/v2/psgc-all-regions.gql';
import PsgcCities from '@/plugins/graphql/queries/v2/psgc-all-cities.gql';
let PaymentPreferencesCreate = class PaymentPreferencesCreate extends Mixins(PhotoMixin, OrangeThemeMixin, ViewportSizeMixin, Mixins(FormMixin, FormValidationsMixin, RouterParamsAppMixin)) {
    constructor() {
        super(...arguments);
        this.form = {
            accountName: null,
            accountNumber: null,
            firstName: null,
            lastName: null,
            country: null,
            address: null,
            city: null,
            stateProvinceRegion: null,
            zip: null,
            mobile: null,
            isDefault: false,
            nameOnCard: null,
            expiryDate: null,
            securityCode: null,
            cardNumber: null,
            cardHolderEmail: null,
            cardHolderPhoneNumber: null,
            email: null,
            company: null,
        };
        this.confirmationModal = false;
        this.redirectSuccess = '';
        this.defaultAddress = null;
        this.autoFillAddress = false;
        this.confirmXenditCustomerUrl = null;
        this.customerDetails = null;
        this.selectedRegionCode = '0';
        this.regionSelection = [];
        this.citySelection = [];
        this.secretKey = '';
        this.xenditPaymentMethodClient = null;
        this.activePaymentMethod = true;
        this.selectedMethod = {
            name: 'Maya',
            uuid: '2',
            image: require('@/assets/images/maya-text.png'),
            height: '20',
            type: 'EWALLET',
            channel_code: 'PAYMAYA',
        };
        this.availableMethods = [
            // {
            //   name: 'GCash',
            //   uuid: '1',
            //   image: require('@/assets/images/gcashtext.png'),
            //   height: '20',
            //   type: 'EWALLET',
            //   channel_code: 'GCASH',
            // },
            {
                name: 'Maya',
                uuid: '2',
                image: require('@/assets/images/maya-text.png'),
                height: '20',
                type: 'EWALLET',
                channel_code: 'PAYMAYA',
            },
            {
                name: 'Grab Pay',
                uuid: '3',
                image: require('@/assets/images/grabpay.png'),
                height: '25',
                type: 'EWALLET',
                channel_code: 'GRABPAY',
            },
            {
                name: 'ShopeePay',
                uuid: '4',
                image: require('@/assets/images/shopeepay.png'),
                height: '25',
                type: 'EWALLET',
                channel_code: 'SHOPEEPAY',
            },
            {
                name: 'Visa/Mastercard/JCB',
                uuid: '5',
                image: require('@/assets/images/visa-mastercard-jcb.png'),
                height: '25',
            },
        ];
        this.creationType = '';
    }
    handleRegionChange(selectedRegionName) {
        // Find the region object with the matching name
        const selectedRegion = this.regionSelection.find((region) => region.name === selectedRegionName);
        // Check if selectedRegion is found
        if (selectedRegion) {
            // Access the regionCode property of the selected region
            const { regionCode } = selectedRegion;
            this.selectedRegionCode = regionCode;
        }
        else {
            this.selectedRegionCode = '0';
        }
        this.$apollo.queries.cities.refetch();
    }
    onAutoFillAddressChange() {
        const vm = this;
        this.handleRegionChange(vm.defaultAddress.stateProvinceRegion);
        if (vm.autoFillAddress && vm.defaultAddress) {
            this.form.firstName = vm.defaultAddress.firstName;
            this.form.lastName = vm.defaultAddress.lastName;
            this.form.address = vm.defaultAddress.address;
            this.form.city = vm.defaultAddress.city;
            this.form.stateProvinceRegion = vm.defaultAddress.stateProvinceRegion;
            this.form.zip = vm.defaultAddress.zipPostalCode;
            this.form.mobile = vm.defaultAddress.phoneNumber;
            this.form.email = vm.defaultAddress.billingContactEmail;
            this.form.company = vm.defaultAddress.company;
        }
        else {
            this.handleRegionChange('none');
            this.form.firstName = '';
            this.form.lastName = '';
            this.form.address = '';
            this.form.city = '';
            this.form.stateProvinceRegion = '';
            this.form.zip = '';
            this.form.mobile = '';
            this.form.email = '';
            this.form.company = '';
        }
    }
    isValidMobile(mobileNumber) {
        // Remove all spaces from the input
        if (mobileNumber) {
            const cleanedNumber = mobileNumber.replace(/\s/g, '');
            // Test against the regex for the cleaned number
            const phoneNumberRegex = /^\+639\d{9}$/;
            return phoneNumberRegex.test(cleanedNumber);
        }
        return false;
    }
    isValidCardNumber(cardNumber) {
        // Check if the input contains only digits
        if (!/^\d+$/.test(cardNumber)) {
            return false; // Return false if input contains non-numeric characters
        }
        // Luhn algorithm validation
        const digits = cardNumber.split('').map(Number);
        let sum = 0;
        let even = false;
        for (let i = digits.length - 1; i >= 0; i--) {
            let digit = digits[i];
            if (even) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            sum += digit;
            even = !even;
        }
        return sum % 10 === 0;
    }
    async fetchDefaultAddress() {
        try {
            const data = await this.$apollo.query({
                query: DefaultBillingAddress,
                variables: {
                    appUuid: this.appUUID,
                },
            });
            if (data.data.fetchDefaultPaymentMethod) {
                const address = data.data.fetchDefaultPaymentMethod.billingAddress;
                this.defaultAddress = address;
                if (data.data.fetchDefaultPaymentMethod.status !== 'ACTIVE') {
                    this.activePaymentMethod = false;
                    this.form.isDefault = true;
                }
            }
            else {
                this.activePaymentMethod = false;
                this.form.isDefault = true;
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async fetchCustomerDetails() {
        try {
            const data = await this.$apollo.query({
                query: CustomerDetails,
                variables: {
                    appUuid: this.appUUID,
                },
            });
            if (data.data.fetchCustomerDetails) {
                const details = data.data.fetchCustomerDetails;
                this.customerDetails = details;
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async fetchRegions() {
        try {
            const data = await this.$apollo.query({
                query: PsgcRegions,
            });
            if (data) {
                const psgcRegions = data.data.allPsgcRegions.edges;
                const psgcRegionNode = (sc) => {
                    return new PsgcRegionModel(sc.node);
                };
                this.regionSelection = psgcRegions.map(psgcRegionNode);
            }
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    formCallback() {
        const message = 'Successfully Created Xendit Payment Method';
        this.toggleAlert(message, AlertType.success);
    }
    setCreationType(type) {
        this.creationType = type;
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.confirmationModal = true;
        }
    }
    checkCreationType() {
        if (this.creationType !== 'Visa/Mastercard/JCB') {
            this.submit();
        }
        else {
            this.submitCard();
        }
    }
    async submit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.isRequestOnProcess = true;
            const mutation = this.createPaymentMethod();
            try {
                const data = await mutation;
                const urlString = data.data.xenditCreatePaymentMethod.paymentMethod.originalResponse.actions[0].url;
                this.confirmXenditCustomerUrl = urlString;
                window.location.replace(urlString);
            }
            catch (error) {
                this.errorNotification(error.message);
            }
            finally {
                this.isRequestOnProcess = false;
            }
        }
    }
    async submitCard() {
        const vm = this;
        this.$v.$touch();
        if (!this.$v.$invalid) {
            try {
                await this.requestCreateCardPaymentMethod();
            }
            catch (error) {
                this.errorNotification(error.message);
            }
            finally {
                this.isRequestOnProcess = false;
            }
        }
    }
    async requestCreateCardPaymentMethod() {
        const vm = this;
        const expiryMonth = vm.form.expiryDate.substring(0, 2);
        const expiryYear = vm.form.expiryDate.substring(2);
        const cleanedNumber = vm.form.cardHolderPhoneNumber.replace(/\s/g, '');
        await window.Xendit.payment.createPaymentMethod({
            type: 'CARD',
            reusability: 'MULTIPLE_USE',
            customer_id: vm.customerDetails.customerId,
            card: {
                currency: 'PHP',
                channel_properties: {
                    success_return_url: vm.redirectSuccess,
                    failure_return_url: vm.redirectSuccess,
                },
                card_information: {
                    card_number: vm.form.cardNumber,
                    expiry_month: expiryMonth,
                    expiry_year: expiryYear,
                    cvv: vm.form.securityCode,
                    cardholder_name: vm.form.nameOnCard,
                    cardholder_email: vm.form.cardHolderEmail,
                    cardholder_phone_number: cleanedNumber,
                },
            },
            metadata: {
                is_default: this.form.isDefault,
            },
        }, (err, response) => {
            if (err) {
                this.errorNotification(err.message);
                console.log(err);
                return;
            }
            const urlString = response.actions[0].url;
            vm.createCardPaymentMethod(response);
            window.location.replace(urlString);
        });
    }
    async createPaymentMethod() {
        return this.$apollo.mutate({
            mutation: CreateXenditPaymentMethod,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    billingContactEmail: this.form.email,
                    paymentMethodType: this.selectedMethod.type,
                    channelCode: this.selectedMethod.channel_code,
                    country: 'PH',
                    address: this.form.address,
                    city: this.form.city,
                    stateProvinceRegion: this.form.stateProvinceRegion,
                    zipPostalCode: this.form.zip,
                    phoneNumber: this.form.mobile,
                    paymentCurrency: 'PHP',
                    isDefault: this.form.isDefault,
                    successReturnUrl: this.redirectSuccess,
                    failureReturnUrl: this.redirectSuccess,
                    cancelReturnUrl: window.location.href,
                    company: this.form.company,
                },
            },
        });
    }
    async createCardPaymentMethod(data) {
        return this.$apollo.mutate({
            mutation: CreateXenditCardPaymentMethod,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    country: this.form.country,
                    address: this.form.address,
                    city: this.form.city,
                    stateProvinceRegion: this.form.stateProvinceRegion,
                    zipPostalCode: this.form.zip,
                    phoneNumber: this.form.mobile,
                    paymentCurrency: 'PHP',
                    isDefault: this.form.isDefault,
                    billingContactEmail: this.form.email,
                    paymentMethodParams: {
                        paymentMethodType: data.type,
                        card: data.card,
                        paymentMethodId: data.id,
                        businessId: data.business_id,
                        originalResponse: data,
                        reusability: data.reusability,
                        customerId: data.customer_id,
                        referenceId: data.reference_id,
                        isDefault: this.form.isDefault,
                    },
                },
            },
        });
    }
    get accountNameErrors() {
        const errors = [];
        if (!this.$v.form.accountName.$dirty) {
            return errors;
        }
        if (!this.$v.form.accountName.required) {
            const msg = requiredProperty('Account Name');
            errors.push(msg);
        }
        if (!this.$v.form.accountName.invalidAccountname) {
            const msg = 'Account Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    get accountNumberErrors() {
        const errors = [];
        if (!this.$v.form.cardNumber.$dirty) {
            return errors;
        }
        if (!this.$v.form.cardNumber.required) {
            const msg = requiredProperty('Account Number');
            errors.push(msg);
        }
        if (!this.$v.form.cardNumber.invalidAccountNumber) {
            const msg = 'Account Number is not valid';
            errors.push(msg);
        }
        return errors;
    }
    get phoneErrors() {
        const errors = [];
        if (!this.$v.form.mobile.$dirty) {
            return errors;
        }
        if (!this.$v.form.mobile.required) {
            const msg = requiredProperty('Mobile Number');
            errors.push(msg);
        }
        if (!this.$v.form.mobile.invalidMobile) {
            const msg = 'Mobile Number is invalid';
            errors.push(msg);
        }
        return errors;
    }
    get cardHolderphoneErrors() {
        const errors = [];
        if (!this.$v.form.cardHolderPhoneNumber.$dirty) {
            return errors;
        }
        if (!this.$v.form.cardHolderPhoneNumber.required) {
            const msg = requiredProperty('Card Holder Phone Number');
            errors.push(msg);
        }
        if (!this.$v.form.cardHolderPhoneNumber.invalidMobile) {
            const msg = 'Card Holder Phone Number is invalid';
            errors.push(msg);
        }
        return errors;
    }
    get securityCodeErrors() {
        const errors = [];
        if (!this.$v.form.securityCode.$dirty) {
            return errors;
        }
        if (!this.$v.form.securityCode.required) {
            const msg = requiredProperty('Security Code');
            errors.push(msg);
        }
        if (!this.$v.form.securityCode.invalidSecurityCode) {
            const msg = 'Expiry Date is invalid. Example: 123';
            errors.push(msg);
        }
        return errors;
    }
    get cardExpiryErrors() {
        const errors = [];
        if (!this.$v.form.expiryDate.$dirty) {
            return errors;
        }
        if (!this.$v.form.expiryDate.required) {
            const msg = requiredProperty('Card Expiry Date');
            errors.push(msg);
        }
        if (!this.$v.form.expiryDate.invalidExpiryDate) {
            const msg = 'Expiry Date is invalid. Example: 12/2040';
            errors.push(msg);
        }
        return errors;
    }
    get trailingWhitespace() {
        return (value) => {
            const hasTrailingWhitespace = value.trim() !== value;
            return hasTrailingWhitespace;
        };
    }
    getEmailErrors(emailList, emailType, emailTypeSpace) {
        const errors = [];
        let hasWhitespace = false; // Flag to track if any email has whitespace
        if (emailList && this.trailingWhitespace(emailList)) {
            hasWhitespace = true;
            errors.push('Invalid input. Please make sure that there are no whitespaces before or after the email addresses provided');
        }
        // If no whitespaces were found and there are other errors, push the invalidType error message
        if (!hasWhitespace && this.$v.form[emailType].$anyError) {
            errors.push(invalidType(emailTypeSpace));
        }
        return errors;
    }
    cardHolderEmailErrors(emailList, emailType, emailTypeSpace) {
        const errors = [];
        let hasWhitespace = false; // Flag to track if any email has whitespace
        if (emailList && this.trailingWhitespace(emailList)) {
            hasWhitespace = true;
            errors.push('Invalid input. Please make sure that there are no whitespaces before or after the email addresses provided');
        }
        // If no whitespaces were found and there are other errors, push the invalidType error message
        if (!hasWhitespace && this.$v.form[emailType].$anyError) {
            errors.push(invalidType(emailTypeSpace));
        }
        return errors;
    }
    isValidExpiryDate(expiryDate) {
        // Check if the format is "MMYYYY"
        const dateRegex = /^(0[1-9]|1[0-2])\d{4}$/;
        if (!dateRegex.test(expiryDate)) {
            return false; // Return false if the format is incorrect
        }
        // Extract month and year
        const month = Number(expiryDate.substring(0, 2));
        const year = Number(expiryDate.substring(2));
        // Check if the month is between 1 and 12
        if (month < 1 || month > 12) {
            return false;
        }
        // Check if the year is a valid future year
        const currentYear = new Date().getFullYear();
        if (year < currentYear) {
            return false; // Assuming a maximum of 10 years in the future
        }
        // If all checks pass, return true
        return true;
    }
    isvalidSecuriyCode(securityCode) {
        // Regular expression to match exactly three digits
        const digitRegex = /\d{3}/;
        // Test if the text contains exactly three digits
        return digitRegex.test(securityCode);
    }
    get firstNameErrors() {
        const errors = [];
        if (!this.$v.form.firstName.$dirty) {
            return errors;
        }
        if (!this.$v.form.firstName.required) {
            const msg = requiredProperty('First Name');
            errors.push(msg);
        }
        if (!this.$v.form.firstName.invalidFirstName) {
            const msg = 'First Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    get lastNameErrors() {
        const errors = [];
        if (!this.$v.form.lastName.$dirty) {
            return errors;
        }
        if (!this.$v.form.lastName.required) {
            const msg = requiredProperty('Last Name');
            errors.push(msg);
        }
        if (!this.$v.form.lastName.invalidLastName) {
            const msg = 'Last Name Contains Invalid Characters';
            errors.push(msg);
        }
        return errors;
    }
    hasUrl(name) {
        const urlRegex = new RegExp('([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?');
        return !urlRegex.test(name);
    }
    loadScipt(src) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
        });
    }
    async xenditScript() {
        try {
            await this.loadScipt('https://js.xendit.co/v3/xendit.min.js');
            if (window.Xendit) {
                window.Xendit.setPublishableKey(process.env.VUE_APP_XENDIT_PUBLIC_API_KEY || '');
            }
        }
        catch (error) {
            console.error('Failed to load Xendit script', error);
        }
    }
    async mounted() {
        await this.xenditScript();
        this.fetchDefaultAddress();
        this.fetchCustomerDetails();
        this.fetchRegions();
        const { key, appUUID } = this.$route.params;
        sessionStorage.setItem('redirectUrl', 'saved-payment-methods');
        this.redirectSuccess = `${window.location.origin}/apps/${key}/${appUUID}/redirect`;
    }
};
__decorate([
    Watch('autoFillAddress')
], PaymentPreferencesCreate.prototype, "onAutoFillAddressChange", null);
PaymentPreferencesCreate = __decorate([
    Component({
        components: {
            BaseTextField,
            ActionButton,
            FormHeader,
            ToggleConfirmationDialog,
            PhoneInput,
        },
        validations() {
            const v = this;
            const cardCreation = () => v.selectedMethod.name === 'Visa/Mastercard/JCB';
            const notRequired = () => false;
            const validations = {
                form: {
                    nameOnCard: {
                        required: requiredIf(cardCreation),
                    },
                    expiryDate: {
                        required: requiredIf(cardCreation),
                        invalidExpiryDate() {
                            // Only run this validation if expiryDate is required
                            if (!cardCreation()) {
                                return true; // If not required, consider it valid to bypass this validation
                            }
                            const vm = this;
                            const { expiryDate } = vm.form;
                            return vm.isValidExpiryDate(expiryDate);
                        },
                    },
                    securityCode: {
                        required: requiredIf(cardCreation),
                        invalidSecurityCode() {
                            // Only run this validation if expiryDate is required
                            if (!cardCreation()) {
                                return true; // If not required, consider it valid to bypass this validation
                            }
                            const vm = this;
                            const { securityCode } = vm.form;
                            return vm.isvalidSecuriyCode(securityCode);
                        },
                    },
                    cardNumber: {
                        required: requiredIf(cardCreation),
                        invalidAccountNumber() {
                            if (!cardCreation()) {
                                return true;
                            }
                            const vm = this;
                            const { cardNumber } = vm.form;
                            return vm.isValidCardNumber(cardNumber);
                        },
                    },
                    cardHolderEmail: {
                        required: requiredIf(cardCreation),
                        email,
                    },
                    cardHolderPhoneNumber: {
                        required: requiredIf(cardCreation),
                        invalidMobile() {
                            if (!cardCreation()) {
                                return true;
                            }
                            const vm = this;
                            const { cardHolderPhoneNumber } = this.form;
                            return vm.isValidMobile(cardHolderPhoneNumber);
                        },
                    },
                    firstName: {
                        required,
                        invalidFirstName() {
                            const vm = this;
                            const { firstName } = this.form;
                            return vm.hasUrl(firstName);
                        },
                    },
                    lastName: {
                        required,
                        invalidLastName() {
                            const vm = this;
                            const { lastName } = this.form;
                            return vm.hasUrl(lastName);
                        },
                    },
                    country: {
                        required: requiredIf(notRequired),
                    },
                    address: {
                        required,
                    },
                    city: {
                        required,
                    },
                    stateProvinceRegion: {
                        required,
                    },
                    zip: {
                        required,
                    },
                    mobile: {
                        required,
                        invalidMobile() {
                            const vm = this;
                            const { mobile } = this.form;
                            return vm.isValidMobile(mobile);
                        },
                    },
                    isDefault: {
                        required: requiredIf(notRequired),
                    },
                    email: {
                        required,
                        email,
                    },
                    company: {
                        required: requiredIf(notRequired),
                    },
                },
            };
            return validations;
        },
        apollo: {
            cities: {
                query: PsgcCities,
                variables() {
                    return {
                        regionCode: this.selectedRegionCode,
                    };
                },
                fetchPolicy: 'cache-and-network',
                update(data) {
                    const psgcCities = data.filteredPsgcCities.edges;
                    const psgcRegionNode = (sc) => {
                        return new PsgcCityModel(sc.node);
                    };
                    this.citySelection = psgcCities.map(psgcRegionNode);
                    return this.citySelection;
                },
            },
        },
    })
], PaymentPreferencesCreate);
export default PaymentPreferencesCreate;
